import type { FormKitNode } from "@formkit/core";

export const validateRatio = (node: FormKitNode): boolean => {
  const ratioRegex = /^\d+(\.\d+)?\s*:\s*\d+(\.\d+)?$/;
  if (typeof node.value === "string") {
    return ratioRegex.test(node.value);
  }
  return false;
};
